import { MarkCreationPayload } from "@modules/mark/types";

import { IMarkFormData, ImageCreationType } from "./types";

export const prepareClonedData = (
  data: IMarkFormData,
): MarkCreationPayload => {
  const {
    latitude,
    longitude,
    marketId,
    visible,
    pastry,
    iceCream,
    pudding,
  } = data;

  return {
    latitude,
    longitude,
    marketId: marketId || null,
    visible,
    pastry,
    iceCream,
    pudding,
  };
};
